import { Component, computed } from '@angular/core';
import { WorkspaceService } from '../../workspace/workspace.service';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { DocPickerTableComponent } from '../doc-picker-table/doc-picker-table.component';
import { DocDto } from '../../dto/doc-dto';
import { ShellMessageService } from '../../services/shell-message.service';
import { FilePickerResponseMessage } from '../../../../../commondata/messages/messages-dto';
import { MODULE_TYPE } from '../../../../../commondata/messages/msg-constants';
import { ShellEmittersService } from '../../shell-emitters.service';

@Component({
    selector: 'app-doc-picker',
    imports: [DocPickerTableComponent, MatButtonModule, MatDialogModule, TranslateModule],
    templateUrl: './doc-picker.component.html',
    styleUrl: './doc-picker.component.scss'
})
export class DocPickerComponent {

  public fromGuid: string = '';
  public docType: string = '';
  public dialogRef: MatDialogRef<DocPickerComponent> | undefined;
  public selectedDoc: DocDto | null = null;

  hasTableDocs = computed(() => {
    switch (this.docType) {
      case 'map':
        return this.workspaceService.maps().length > 0;
      case 'doc':
        return this.workspaceService.docs().length > 0;
      case 'pdf':
        return this.workspaceService.pdfs().length > 0;
      default:
        return false;
    }
  });

  constructor(
    public workspaceService: WorkspaceService,
    public shellMessageService: ShellMessageService,
    private shellEmittersService: ShellEmittersService
  ) {

  }

  selectedFile(doc: DocDto) {
    this.selectedDoc = doc;
  }

  insertInDocument() {
    if (this.selectedDoc) {
      this.shellMessageService.sendMessageToFocusedModule(
        new FilePickerResponseMessage(MODULE_TYPE.SHELL, this.selectedDoc.id, this.selectedDoc.docType, this.selectedDoc.name)
      );
      if (this.dialogRef) {
        this.dialogRef.close();
      }
    }
  }

  insertNew() {
    this.shellEmittersService.onAttachNewDoc.emit({ docType: this.docType, fromGuid: this.fromGuid });
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

}
